import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    container: {display: "flex", alignItems: "center", minHeight: 55},
    unit: {paddingLeft: '0.5rem'}
}));

export default useStyles;